import React from 'react';
import { useNavigate } from 'react-router-dom';
import {  Skeleton, SkeletonCircle, SkeletonBar } from '../../util/skeleton/Skeleton';
import { useAuth } from '../../DataStore/AuthContext';
import { formatMoney, tell_when } from '../../util/araknerdlib';

const RecentVoucherSkeleton = () => (
  <div className="of-card">
    <div className="of-list-head">
      <div>
        <Skeleton w="160px" h={16} />
        <Skeleton w="100px" h={12} style={{ marginTop: 6 }} />
      </div>
      <Skeleton w="80px" h={28} />
    </div>

    <div className="of-list">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="of-item">
          <div className="of-item-left">
            <SkeletonCircle size={36} />
            <div style={{ marginLeft: 12, flex: 1 }}>
              <Skeleton w="140px" h={14} />
              <Skeleton w="180px" h={12} style={{ marginTop: 6 }} />
            </div>
          </div>
          <Skeleton w="60px" h={14} />
        </div>
      ))}
    </div>

    <div className="p-3 pt-2">
      <SkeletonBar h={36} />
    </div>
  </div>
);

const RecentVoucher = ({ recentSales, currency }) => {
  const navigate = useNavigate();
  

  if (!recentSales) {
    return <RecentVoucherSkeleton />;
  }

  if (!Array.isArray(recentSales) || recentSales.length === 0) {
    return (
      <div className="of-card p-3 text-center text-muted">
        No recent voucher sales
      </div>
    );
  }

  return (
    <div className="of-card">
      <div className="of-list-head">
        <div>
          <div className="of-list-title">Recent Vouchers</div>
          <div className="of-list-sub">Latest sales</div>
        </div>
        <button
          className="btn btn-sm of-btn-ghost"
          type="button"
          onClick={() => navigate('/vouchers')}
        >
          <i className="fas fa-list mr-2" />
          View all
        </button>
      </div>

      <div className="of-list">
        {recentSales.map((v) => (
          <div key={v.id} className="of-item">
            <div className="of-item-left">
              <div className="of-item-ico">
                <i className="fas fa-wifi" />
              </div>
              <div>
                <div className="of-item-title">{v.plan_name.toLowerCase()}</div>
                <div className="of-item-sub">
                    <span className="of-code">{v.code}</span>
                </div>
              </div>
            </div>

           
            <div className="of-item-right of-item-right-stack">
                <div className="of-item-amount">
                    {formatMoney(v.amount, currency)}
                </div>
                <div className="of-item-date">
                    {tell_when(v.created_at)}
                </div>
            </div>

          </div>
        ))}
      </div>

      <div className="p-3 pt-2">
        <button
          className="btn btn-block of-btn-ghost"
          type="button"
          onClick={() => navigate('/vouchers')}
        >
          <i className="fas fa-chevron-right mr-2" />
          View all vouchers
        </button>
      </div>
    </div>
  );
};

export default RecentVoucher;
